import * as requestFromServer from './bankStatementsCrud';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {v4 as guid} from 'uuid';
import {CreateReceiptDTO, MatchSourceRow} from '../types';

export const matchInvoicesPrefix = 'matchInvoicesPrefix';
export const createReceiptPrefix = 'createReceiptPrefix';

export const matchInvoices = async (data: MatchSourceRow[]) => {
  const requestID = `${matchInvoicesPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);
  const response = await requestFromServer.matchInvoices(data, cancellationHandlers);
  RequestCancellationManager.forgetRequest(requestID);
  if (response?.data?.errorCode !== 0) {
    return []
    throw new Error('Invoice matching failed');
  } else {
    return response?.data?.data?.matchedInvoices;
  }
};

export const createReceipt = async (data: Omit<CreateReceiptDTO, 'multipleAgents'>) => {
  const requestID = `${createReceiptPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);
  const response = await requestFromServer.createReceipt({multipleAgents: 0, ...data}, cancellationHandlers);
  RequestCancellationManager.forgetRequest(requestID);

  if (response.data.errorCode !== 0) {
    throw new Error('Receipt creation failed');
  }

  return response?.data?.data?.receiptID;
};